import { render } from "./LightboxCategoryRevenue.vue?vue&type=template&id=6d0fab4e"
import script from "./LightboxCategoryRevenue.vue?vue&type=script&lang=js"
export * from "./LightboxCategoryRevenue.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__